export default __webpack_public_path__ + "static/media/ayalon1.0eca4210.jpg";